import Modal from "../Base/Modal";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  width: 500px;

  .headerTabs {
    display: flex;
    gap: 20px;

    .tab {
      font-weight: 700;
      font-size: 20px;
      color: #004576;
    }

    .activeTab {
      border-bottom: 3px solid #48c8f4;
    }

    .closeButtonModal {
      margin-left: 336px;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .clientName {
    font-weight: 700;
    font-size: 16px;
    color: #211c1d;
    margin-top: 24px;
  }

  .infoSection {
    margin-top: 20px;

    .section {
      margin-top: 20px;
      .header {
        font-weight: 400;
        font-size: 12px;
        color: #211c1d;
      }

      .info {
        font-weight: 400;
        font-size: 16px;
        color: #3a3a3d;
        margin-top: 5px;
      }

      .emailLink {
        color: #008df1;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
`;

const AdvisorDetailsModal = ({
  data,
  isAdvisorDetailsModalShow,
  advisorDetailsModalOnClose,
}) => {
  const handleMailClick = (mailId) => {
    window.open(`mailto:${mailId}`);
  };

  const formatPhoneNumber = (str) => {
    let cleaned = ("" + str).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  };

  return (
    <Modal
      show={isAdvisorDetailsModalShow}
      onClose={advisorDetailsModalOnClose}
    >
      <Wrapper>
        <div className="headerTabs">
          <div className="tab">Advisor Details</div>
          <div
            className="closeButtonModal"
            onClick={advisorDetailsModalOnClose}
          >
            X
          </div>
        </div>
        <div className="clientName">{data?.fullName || ""}</div>
        <div className="infoSection">
          <div className="section">
            <div className="header">Advisor Code</div>
            <div className="info">{data?.advisorCode || ""}</div>
          </div>
          <div className="section">
            <div className="header">RIA</div>
            <div className="info">{data?.ria || ""}</div>
          </div>
          <div className="section">
            <div className="header">Email</div>
            <div
              className="info emailLink"
              onClick={() => handleMailClick(data?.email)}
            >
              {data?.email || ""}
            </div>
          </div>
          <div className="section">
            <div className="header">Phone</div>
            <div className="info">{formatPhoneNumber(data?.phone) || ""}</div>
          </div>
          <div className="section">
            <div className="header">Address</div>
            <div className="info">
              {data?.addressLineOne || ""}
              {", "}
              <br></br>
              {data?.city || ""}
              {", "}
              {data?.state || ""}
              {", "}
              {data?.zipCode || ""}{" "}
            </div>
          </div>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default AdvisorDetailsModal;
